
const mutations = {
  SET_VOLATILITY_RETURN(state, payload) {
    const deviationAsOfDate = payload.returns && payload.returns.fundList && payload.returns.fundList[0] && payload.returns.fundList[0].MStarStandardDeviation10YrAsOfDateFormatted || null;
    const returnAsOfDate = payload.returns && payload.returns.fundList && payload.returns.fundList[0] && payload.returns.fundList[0].CGAvgAnnualReturn10YrAsOfDateFormatted || null;
    const inceptionDate = payload.returns && payload.returns.meta && payload.returns.meta[0] && payload.returns.meta[0].Inceptiondate || null;

    if (payload.equityChart) {
      const equityLargeChart = payload.equityLargeChart && payload.equityLargeChart.chart || null;
      const equityChart = payload.equityChart && payload.equityChart.chart || payload.equityChart || null;
      const equityLargeOutput = payload && payload.equityLargeChart && payload.equityLargeChart.output && JSON.parse(payload.equityLargeChart.output) || null;
      const equityOutput = payload && payload.equityChart && payload.equityChart.output && JSON.parse(payload.equityChart.output) || null;
      const equityStrategyData = equityOutput && equityOutput.FundData || null;
      const equityIndexData = equityOutput && equityOutput.IndexData || null;

      const fixedIncomeLargeChart = payload.fixedIncomeLargeChart && payload.fixedIncomeLargeChart.chart || null;
      const fixedIncomeChart = payload.fixedIncomeChart && payload.fixedIncomeChart.chart || payload.fixedIncomeChart || null;
      const fixedIncomeLargeOutput = payload && payload.fixedIncomeLargeChart && payload.fixedIncomeLargeChart.output && JSON.parse(payload.fixedIncomeLargeChart.output) || null;
      const fixedIncomeOutput = payload && payload.fixedIncomeChart && payload.fixedIncomeChart.output && JSON.parse(payload.fixedIncomeChart.output) || null;
      const fixedIncomeStrategyData = fixedIncomeOutput && fixedIncomeOutput.FundData || null;
      const fixedIncomeIndexData = fixedIncomeOutput && fixedIncomeOutput.IndexData || null;

      state.volatilityData = {
        deviationAsOfDate,
        returnAsOfDate,
        inceptionDate,
        equityChart,
        equityLargeChart,
        equityOutput,
        equityLargeOutput,
        equityStrategyData,
        equityIndexData,
        fixedIncomeChart,
        fixedIncomeLargeChart,
        fixedIncomeOutput,
        fixedIncomeLargeOutput,
        fixedIncomeStrategyData,
        fixedIncomeIndexData
      };

    } else {
      const largeChart = payload.largeChart && payload.largeChart.chart || null;
      const largeOutput = payload && payload.largeChart && payload.largeChart.output && JSON.parse(payload.largeChart.output) || null;
      const chart = payload.chart && payload.chart.chart || payload.chart || null;
      const output = payload && payload.chart && payload.chart.output && JSON.parse(payload.chart.output) || null;
      const strategyData = output && output.FundData || null;
      const indexData = output && output.IndexData || null;

      state.volatilityData = {
        deviationAsOfDate,
        returnAsOfDate,
        inceptionDate,
        chart,
        largeChart,
        output,
        largeOutput,
        strategyData,
        indexData
      };
    }
  }
};

const getters = {
  volatilityData: state => state.volatilityData
};

const state = {
  volatilityData: null
};

export default {
  state,
  mutations,
  getters
};
